module.exports = __webpack_public_path__ + "static/media/filter-function.bc95150a.jpeg";